export const environment = {
  production: true,
  environment: "qa",
  ENV: 'QA',
  maintenanceMode: false,
  subject: "Compare the Market Energy Sign In",
  api_url: 'https://api.qa.perswitch.co.uk/energy-ui',
  api_url_meter: 'https://api.qa.perswitch.co.uk/meter-ui/v1/',
  contact_api_url: 'https://api.qa.perswitch.co.uk/v1/',
  p2s_api: 'https://api.qa.perswitch.co.uk/p2s-ui/v1/',
  home_url: 'https://ui.qa.perswitch.co.uk/',
  email_api: 'https://api.qa.perswitch.co.uk/oe-transform-util/v1/',
  dashboard_url: 'https://preprod.dashboard.thelabrador.co.uk/login',
  api_url_ev: 'https://api.qa.perswitch.co.uk/evcompare-ui/v1/',
  // api_url_ev: 'https://dev.api.thelabrador.co.uk/evcompare/v1/',
  login_api: 'https://api.qa.perswitch.co.uk/reporting/v1/',
  lab_v1_url: 'https://api.thelabrador.co.uk/meterhistory/v1/',

  IDB_DB_NAME: 'dpop-keys',
  IDB_STORE_NAME: 'session',
  SESSION_KEY_ID: 'dpop-session-keypair-v1',

  analytics_v1_url: 'https://api.qa.perswitch.co.uk/oe-transform-util/v1',

  ads_url: '/v1/users',
  product_url: '/v1/users/product/productConfig',
  transaction_url: '/v1/users/product/transaction',

  gbgVersion: '2.0',
  gtag: 'UA-103774971-4',
  gtm: 'GTM-KKCBBQB',

  arkoseProduct: '',
  arkoseCompany: '',
  arkoseKey: '',

  // Gtag for internal tracking
  gtagPerse: 'G-PPCW5KQ77Z',

  faq: 'https://www.thelabrador.co.uk/faqs',
  netzeroBlog: 'https://netzero.thelabrador.co.uk/blog',

  S3_url: 'https://ctm-content-dev.s3.eu-west-2.amazonaws.com/',

  tealium_account: 'ctm',
  tealium_profile: 'energy-comparison',
  tealium_environment: 'qa',
  tealium_app_environment: 'test',
  tealium_app_name: "Energy Comparison",
  tealium_app_platform_release: 1781164539,
  tealium_app_campaign_maskcode: "CM01",

  isSMCFeature: true,
  isEVFeature: true,

  // Socket.IO presence configuration (disabled for QA)
  socketPresence: {
    enabled: false,
    serverUrl: ''
  },
  perseUrl: 'https://api.perse.io',

  // Application version
  appVersion: '3'
};

export const jwt = {
  authorizeURL: 'https://api.qa.perswitch.co.uk/oauth/authorize'
};

